webpackJsonp([114276838955818,60335399758886],{

/***/ 253:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Ice Cream on a Sunday"}}},"layoutContext":{}}

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(352);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(253);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  padding: ', ' ', ' ', ';\n  position: sticky;\n  top: 0;\n  z-index: ', ';\n\n  @media screen and (min-width: ', ') {\n    padding: ', ';\n  }\n'], ['\n  background-color: ', ';\n  padding: ', ' ', ' ', ';\n  position: sticky;\n  top: 0;\n  z-index: ', ';\n\n  @media screen and (min-width: ', ') {\n    padding: ', ';\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  max-width: ', ';\n\n  @media screen and (min-width: ', ') {\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n'], ['\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  max-width: ', ';\n\n  @media screen and (min-width: ', ') {\n    align-items: center;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: block;\n'], ['\n  display: block;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  width: 400px;\n\n  @media screen and (min-width: ', ') {\n    margin-bottom: 0;\n  }\n'], ['\n  width: 400px;\n\n  @media screen and (min-width: ', ') {\n    margin-bottom: 0;\n  }\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  -webkit-appearance: none;\n  background-color: transparent;\n  border: none;\n  color: ', ';\n  cursor: pointer;\n  font-weight: bold;\n  height: 21px;\n\n  @media screen and (min-width: ', ') {\n    display: none;\n  }\n'], ['\n  -webkit-appearance: none;\n  background-color: transparent;\n  border: none;\n  color: ', ';\n  cursor: pointer;\n  font-weight: bold;\n  height: 21px;\n\n  @media screen and (min-width: ', ') {\n    display: none;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  // display: none;\n  display: flex;\n  justify-content: flex-end;\n  justify-content: center;\n  list-style-type: none;\n  margin: 0;\n'], ['\n  // display: none;\n  display: flex;\n  justify-content: flex-end;\n  justify-content: center;\n  list-style-type: none;\n  margin: 0;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  margin: 0 ', ';\n'], ['\n  margin: 0 ', ';\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n'], ['\n  color: ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(38);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _get = __webpack_require__(19);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _reactHelmet = __webpack_require__(43);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _variables = __webpack_require__(16);
	
	var _logo = __webpack_require__(670);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _hamburgerMenu = __webpack_require__(667);
	
	var _hamburgerMenu2 = _interopRequireDefault(_hamburgerMenu);
	
	var _activeLinkDrip = __webpack_require__(664);
	
	var _activeLinkDrip2 = _interopRequireDefault(_activeLinkDrip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SiteHeaderWrapper = _styledComponents2.default.header(_templateObject, _variables.Colors.accentColor, _variables.Spacing.spacingSmall, _variables.Spacing.spacingMedium, _variables.Spacing.spacingBase, _variables.Zindices.modal, _variables.Sizes.breakpointSmall, _variables.Spacing.spacingMedium);
	
	var Navigation = _styledComponents2.default.nav(_templateObject2, _variables.Sizes.contentWidth, _variables.Sizes.breakpointSmall);
	
	var SiteTitle = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject3);
	
	var Logo = _styledComponents2.default.img(_templateObject4, _variables.Sizes.breakpointSmall);
	
	var MobileMenuButton = _styledComponents2.default.button(_templateObject5, _variables.Colors.pageBackground, _variables.Sizes.breakpointSmall);
	
	var LinksList = _styledComponents2.default.ul(_templateObject6);
	
	var ListItem = _styledComponents2.default.li(_templateObject7, _variables.Spacing.spacingBase);
	
	var NavLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject8, _variables.Colors.pageBackground);
	
	var activeLinkStyle = {
	  borderBottom: "4px solid",
	  fontFamily: "Circular-Bold",
	  paddingBottom: 5
	};
	
	var SiteHeader = function (_React$Component) {
	  _inherits(SiteHeader, _React$Component);
	
	  function SiteHeader(props) {
	    _classCallCheck(this, SiteHeader);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.componentDidMount = function () {
	      window.addEventListener('scroll', this.handleScroll);
	    };
	
	    _this.handleScroll = function (event) {
	      var main = document.getElementsByTagName('main')[0];
	      var fromTop = main.pageYOffset;
	      var size = void 0;
	
	      if (fromTop <= 70 || fromTop === 0) {
	        size = 70;
	        // size = Math.round(70 - ((fromTop / 72) * (70 - 24)))
	        console.log("fromTop " + fromTop);
	      } else {
	        size = 24;
	      }
	
	      _this.setState({
	        titleFontSize: _this.state.titleFontSize = size + 'px'
	      }, function () {
	        console.log(_this.state.titleFontSize);
	      });
	    };
	
	    _this.state = {
	      titleFontSize: '70px'
	    };
	    return _this;
	  }
	
	  SiteHeader.prototype.render = function render() {
	    return _react2.default.createElement(
	      SiteHeaderWrapper,
	      null,
	      _react2.default.createElement(
	        Navigation,
	        null,
	        _react2.default.createElement(
	          SiteTitle,
	          {
	            exact: true, to: '/'
	          },
	          _react2.default.createElement(Logo, { src: _logo2.default })
	        ),
	        _react2.default.createElement(
	          LinksList,
	          null,
	          _react2.default.createElement(
	            ListItem,
	            null,
	            _react2.default.createElement(
	              NavLink,
	              {
	                exact: true, to: '/',
	                activeStyle: activeLinkStyle },
	              'Home'
	            )
	          ),
	          _react2.default.createElement(
	            ListItem,
	            null,
	            _react2.default.createElement(
	              NavLink,
	              {
	                exact: true, to: '/posts',
	                activeStyle: activeLinkStyle },
	              'All Recipes'
	            )
	          ),
	          _react2.default.createElement(
	            ListItem,
	            null,
	            _react2.default.createElement(
	              NavLink,
	              {
	                exact: true, to: '/about',
	                activeStyle: activeLinkStyle },
	              'About'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return SiteHeader;
	}(_react2.default.Component);
	
	exports.default = SiteHeader;
	
	// <MobileMenuButton>
	//             Menu <span aria-hidden="true">😋</span>
	//           </MobileMenuButton>
	
	module.exports = exports['default'];

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Ahkio-Black.57beb2d0.woff";

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Ahkio-Bold.c4109eba.woff";

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Ahkio-Regular.e716571f.woff";

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/CircularStd-Bold.fb82fa79.woff";

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/CircularStd-Book.e2652d8d.woff";

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNDZweCIgaGVpZ2h0PSIyNXB4IiB2aWV3Qm94PSIwIDAgNDYgMjUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU0LjEgKDc2NDkwKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5QYXRoIDQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9Ik5hdmlnYXRpb24vRGVza3RvcC1IZWFkZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05MzUuMDAwMDAwLCAtMTkwLjAwMDAwMCkiIGZpbGw9IiNGOUY5RjciPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODY5LjAwMDAwMCwgMTY2LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTY2LDI5LjU0MjQ1NDkgQzY2LDM1LjQ1NTU5MDUgNjcuOTk2NjM3OSwzOC40MTIxNTgyIDcxLjk4OTkxMzYsMzguNDEyMTU4MiBDNzUuMTUzMDA2NCwzOC40MTIxNTgyIDc2Ljg4NDQ1OTEsMzYuOTU0ODE2NiA3Ny4xODQyNzE1LDM0LjA0MDEzMzIgQzc3LjQ5MDc5NDQsMzEuMDQxNjgxIDc5LjEzNjYwOTEsMjkuNTQyNDU0OSA4Mi4xMjE3MTU3LDI5LjU0MjQ1NDkgQzg1LjEwNjgyMjMsMjkuNTQyNDU0OSA4Ni45MTk1Njc3LDMxLjA0MTY4MSA4Ny41NTk5NTE5LDM0LjA0MDEzMzIgQzg4LjA2NDA5NzcsNDMuNDQxMzA5NCA5Mi4yNjM0NzU1LDQ4LjE0MTg5NzUgMTAwLjE1ODA4NSw0OC4xNDE4OTc1IEMxMDguMDUyNjk1LDQ4LjE0MTg5NzUgMTEyLDQxLjk0MjA4MzMgMTEyLDI5LjU0MjQ1NDkgTDExMiwyNCBMOTQuODMyMTY3OCwyNCBMNjYsMjQgTDY2LDI5LjU0MjQ1NDkgWiIgaWQ9IlBhdGgtNCI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAACCUlEQVQ4jY2Qv2tUQRSFB0QTImiMwchmd9/MnQ0SFaM83c1m5g4KQkyRRgkiBFsrQfC3jaIogrVgoZ2d+QcEm1SCBDSCrqKojSEuvjmzL4lg1H02FhLZXU95OXyH+wmxJolVU/UDcvvfN4xKmRq1Y233n7zaJTaAqZmwHA9MtzyrO/VqtA+OlgPr18Goc20B2NvbC6czsLrumVIwzYJpBqxXwTTvTTTRFuDjLZvhdAZLD8D0IZQjFayaAtMvMM14I0+1BczFYj2YmrDqJJiS4OgnDB1tWHkCjq6lca6/o4dg5aVgi7QQ53q+VLYNZAdld1YqdQWWFxqspjMh1rX3YKJDwcjjjUp+KDC9gVXPYdWN4KgGpk9JVY63dmBzxT/CXnhL9+B05i3d9UwPwfozrHq0uGdgY0tAatWkZ1ppVPJDKA+OwOlsyUXDDVbTYPoGJg+rRloC6tV8KbD+Dqb33srb3lItjBW0EEL4scLupdFouJNDkVSKOwPTsXcl0bUQ53rSONfvjWLPajowXe4IAKvTgfXN1CgOjmrB0SKYmmB6Bqeztg68iSbgaBlMs8HRY8/0ElZeBVMzGHUeTmdJpW9T63WrzoJpHpbug+kJmOaClRfB1ISRZ8C08lGK7paAr7Z4GE7/ANPb4PRTz+qKt2oysfJIo5rv6/i/EEIEU9iflge3/ldZCPEb+nTtmiUcjrwAAAAASUVORK5CYII="

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEjElEQVRYhc2Xf4hVRRTHjyn5CzG3xZW3d9+dOXcLQ7Lysb53750zbIb2w8Qo/wzCggwpjcgsMJFI+qOISpKCoiyUiErBfkAS/mVgIEW1EQkZiO26b++ceeu6WLp7+2PnvnctU3lvpc4/bxjmzvczZ845cx7A/92Mwt1MuJeVWHuxdcNLO69lhRtrJB+15C+ZFPG0F6ZZjedYBymT3AEAcKxXzLCRXFFTopx2w3QAgKPdMJ0Jf2QdpBNrcZyV3J8CTGkJYLhUaK9vqnHb8dCbyYRHsjmrkVmJtYbk/dncUCweqH9TEaIlAKMKxYaYfJKV2OBOOGYVfu7AfmCNb7t1VVZiI+sgNRr7+xbB1S0BWFXEhlvlY1bjlw7giCW5hnVwlglfZsJPG54KUib8JYlFpSVxAAC71JfZpkbhekP4M+sgtYQfpb1iRloqzJrwlNzlvHGmFvt3GeWvZ5KvtQyQlDu9DKCmcD0TfuOEvq3G7XNMLNbZWD7EMd57ngd0kDIFZ01p3tyWAGqh11bfUIkNRuEL/xDSOAAAYJXYzISJC84BG/n3teyBDwGmsktDS8FTpoRzmfAAE467ux5lhQ9m61OAq0Z6xIKDvTCtZfHMmLCPCceZ5HPZ3FAoFiaxXH6yPL/jQt9k9WFSLAWYYkrz5h69yKY26goAADiSvsmAdXCcFb5SjdvnTBpMZklcXGQJPzMk93EkVlvCPwZ7xAImuY91kBoKTjBh38RYvtiSGEdSM+FhS3jYKnz9VMW/wUb+slzOj06kqVzFFPw5EbByCxPudeNXmxavhV4bE5osx92vHQqLt+UzwVLwU6LE2hzU90w4ZgkHa6HX3TSAJfFI9rgYVbzbldiRJPLDTCwhsTUFmGIr/pJcDThkFD7NkVidht7M5gEUvuE2HeKbxTUmlts59m9lJW9qnF6uAQBIQ28maxxxwL8y4SEmHDckNzUNwITvuA0HASbyfLDsXTccioUNAKwXHBvLTfUa4eLDxP6dTQMYJTbn3vdd7uWrGvIWXwgAAMCqYolJPssKtw2rzuubFgcAqN7SVWAdVPMBZzT2c2WBYCV3MeFXifajlkQuZUlPoYuVfMmS/MIS7hwtd3qX+mYwktpG/rIrClaN2+ckPYWudHHHbBvL5azw4xqJ22uxqLDGc0w4bgn3TIrYSHl+B1eESAGmZnOGcL+Lj++yV5AJx5jwt/NqxI3FeU0LpwBT3V1nr99pS3jAqKJijZ/U44KwvzEOvjZxsL3eI4ZeZ9MAJhbrcu/+8VzkP2NIfuDER5Nyp5dBGiWft0o+nOukik0DMAUH3cn7BkOvO5ffjzPJ99z4ZHpe3yC358GTywjaiwGccA3pu0O54sMKn2CFb2XdTwowjQnHMg+wwo3Z2n/rGS4PQOOAc/keE/kr8/8RjCvTVuPA76XCrIZ3xFYmcQ9rPGY1nhlY3DG7BQ/gIXfPp1kHp7J7toQ7DckdWU/ognWL0bi7psQdTQv+3Uzkr7Q6OOuERliJbVZjPxO+Xwu9NhvJFS3V+suxRPuRUfLNYSVXXVGh/8r+ApBjKHHQCkmwAAAAAElFTkSuQmCC"

/***/ }),

/***/ 667:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjFweCIgaGVpZ2h0PSIyMXB4IiB2aWV3Qm94PSIwIDAgMjEgMjEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU0LjEgKDc2NDkwKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5JY29uL01lbnU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iSWNvbi9NZW51IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cG9seWdvbiBpZD0iUGF0aC0yIiBmaWxsPSIjRkZGRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHBvaW50cz0iMC41MDQxNjk4MzkgNiAwLjUwNDE2OTgzOSAzIDIwLjYyNjA5MTkgMyAyMC42MjYwOTE5IDYiPjwvcG9seWdvbj4KICAgICAgICA8cG9seWdvbiBpZD0iUGF0aC0yLUNvcHkiIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9pbnRzPSIwLjUwNDE2OTgzOSAxMi4xNzgxODY3IDAuNTA0MTY5ODM5IDkuMTc4MTg2NyAyMC42MjYwOTE5IDkuMTc4MTg2NyAyMC42MjYwOTE5IDEyLjE3ODE4NjciPjwvcG9seWdvbj4KICAgICAgICA8cG9seWdvbiBpZD0iUGF0aC0yLUNvcHktMiIgZmlsbD0iI0ZGRkZGRiIgZmlsbC1ydWxlPSJub256ZXJvIiBwb2ludHM9IjAuNTA0MTY5ODM5IDE4LjE3ODE4NjcgMC41MDQxNjk4MzkgMTUuMTc4MTg2NyAyMC42MjYwOTE5IDE1LjE3ODE4NjcgMjAuNjI2MDkxOSAxOC4xNzgxODY3Ij48L3BvbHlnb24+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 668:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzUiIGhlaWdodD0iMzQiPgogIDxkZWZzPgogICAgPHBhdGggaWQ9ImEiIGQ9Ik0wIC4wNTRoMzMuOTQ2djMzLjk0MkgweiIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLjUpIj4KICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPgogICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgPC9tYXNrPgogICAgICA8cGF0aCBmaWxsPSIjRjlGOUY3IiBkPSJNMTYuOTczLjA1NGMtNC42MSAwLTUuMTg3LjAxOS02Ljk5OC4xMDItMS44MDYuMDgyLTMuMDQuMzctNC4xMi43ODlBOC4zMiA4LjMyIDAgMCAwIDIuODUgMi45MDIgOC4zMTkgOC4zMTkgMCAwIDAgLjg5IDUuOTFjLS40MiAxLjA4LS43MDYgMi4zMTMtLjc4OSA0LjEyQy4wMiAxMS44MzkgMCAxMi40MTcgMCAxNy4wMjdzLjAyIDUuMTg3LjEwMiA2Ljk5OGMuMDgzIDEuODA2LjM3IDMuMDQuNzkgNC4xMmE4LjMxOSA4LjMxOSAwIDAgMCAxLjk1NyAzLjAwNiA4LjMyIDguMzIgMCAwIDAgMy4wMDYgMS45NThjMS4wOC40MiAyLjMxNC43MDYgNC4xMi43ODkgMS44MS4wODIgMi4zODkuMTAyIDYuOTk4LjEwMiA0LjYxIDAgNS4xODgtLjAyIDYuOTk4LS4xMDIgMS44MDctLjA4MyAzLjA0LS4zNyA0LjEyLS43OWE4LjMxOSA4LjMxOSAwIDAgMCAzLjAwNy0xLjk1NyA4LjMyIDguMzIgMCAwIDAgMS45NTctMy4wMDZjLjQyLTEuMDguNzA3LTIuMzE0Ljc5LTQuMTIuMDgyLTEuODEuMTAxLTIuMzg5LjEwMS02Ljk5OCAwLTQuNjEtLjAyLTUuMTg4LS4xMDItNi45OTgtLjA4Mi0xLjgwNy0uMzY5LTMuMDQtLjc4OS00LjEyYTguMzIgOC4zMiAwIDAgMC0xLjk1Ny0zLjAwN0E4LjMxOSA4LjMxOSAwIDAgMCAyOC4wOS45NDVjLTEuMDgtLjQyLTIuMzEzLS43MDctNC4xMi0uNzktMS44MS0uMDgyLTIuMzg4LS4xMDEtNi45OTgtLjEwMW0wIDMuMDU4YzQuNTMyIDAgNS4wNjkuMDE3IDYuODU5LjA5OSAxLjY1NS4wNzUgMi41NTMuMzUyIDMuMTUyLjU4NGE1LjI1OCA1LjI1OCAwIDAgMSAxLjk1MSAxLjI3Yy41OTQuNTk0Ljk2MiAxLjE2IDEuMjcgMS45NTEuMjMyLjU5OS41MDkgMS40OTcuNTg0IDMuMTUyLjA4MiAxLjc5LjEgMi4zMjcuMSA2Ljg1OXMtLjAxOCA1LjA2OS0uMSA2Ljg1OGMtLjA3NSAxLjY1NS0uMzUyIDIuNTU0LS41ODQgMy4xNTJhNS4yNTcgNS4yNTcgMCAwIDEtMS4yNyAxLjk1MiA1LjI1NyA1LjI1NyAwIDAgMS0xLjk1MSAxLjI3Yy0uNTk5LjIzMi0xLjQ5Ny41MDgtMy4xNTIuNTg0LTEuNzkuMDgyLTIuMzI2LjA5OS02Ljg1OS4wOTktNC41MzIgMC01LjA2OS0uMDE3LTYuODU4LS4xLTEuNjU1LS4wNzUtMi41NTQtLjM1MS0zLjE1Mi0uNTg0YTUuMjU4IDUuMjU4IDAgMCAxLTEuOTUyLTEuMjcgNS4yNjEgNS4yNjEgMCAwIDEtMS4yNy0xLjk1Yy0uMjMyLS41OTktLjUwOC0xLjQ5OC0uNTg0LTMuMTUzLS4wODEtMS43OS0uMDk5LTIuMzI2LS4wOTktNi44NThzLjAxOC01LjA2OS4xLTYuODU5Yy4wNzUtMS42NTUuMzUxLTIuNTUzLjU4NC0zLjE1MmE1LjI2IDUuMjYgMCAwIDEgMS4yNy0xLjk1MSA1LjI2IDUuMjYgMCAwIDEgMS45NS0xLjI3Yy41OTktLjIzMiAxLjQ5OC0uNTA5IDMuMTUzLS41ODQgMS43OS0uMDgyIDIuMzI2LS4xIDYuODU4LS4xIiBtYXNrPSJ1cmwoI2IpIi8+CiAgICA8L2c+CiAgICA8cGF0aCBmaWxsPSIjRjlGOUY3IiBkPSJNMTcuNSAyMi44NDJhNS44NDIgNS44NDIgMCAxIDEgMC0xMS42ODQgNS44NDIgNS44NDIgMCAwIDEgMCAxMS42ODRNMTcuNSA4YTkgOSAwIDEgMCAwIDE4IDkgOSAwIDAgMCAwLTE4TTI4LjUgOGEyIDIgMCAxIDEtNCAwIDIgMiAwIDAgMSA0IDAiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),

/***/ 669:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSI5Ij4KICA8cGF0aCBmaWxsPSIjQUJCN0UxIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0xOS4wNjIgNC40N2wtMy41MjYtMi44MTVhLjUuNSAwIDAgMSAuNjI0LS43ODFsNC41NyAzLjY0OWEuNS41IDAgMCAxIC4wMDQuNzc5LjUwMi41MDIgMCAwIDEtLjE1Ni4xMThMMTYuMTUgOC43NzdhLjUuNSAwIDEgMS0uNjA0LS43OTdsMy4zMS0yLjUxSC41MDhhLjUuNSAwIDEgMSAwLTFoMTguNTU0eiIvPgo8L3N2Zz4K"

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.c70775a9.svg";

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pistachio-combined.a6a28f0a.png";

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  text-decoration: none;\n'], ['\n  color: ', ';\n  text-decoration: none;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  align-items: center;\n  background-color: black;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: ', ';\n  width: 100%;\n'], ['\n  align-items: center;\n  background-color: black;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: ', ';\n  width: 100%;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  color: white;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n'], ['\n  color: white;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  margin-top: ', ';\n'], ['\n  margin-top: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n\n  @media screen and (min-width: ', ') {\n    align-items: baseline;\n    flex-direction: row;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n\n  @media screen and (min-width: ', ') {\n    align-items: baseline;\n    flex-direction: row;\n  }\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n\n  &:hover {\n    color: #D2DBF9;\n    transition: color 500ms ease;\n  }\n\n  &::after {\n    content: url(', ');\n    display: inline-block;\n    margin-left: ', ';\n  }\n'], ['\n  color: ', ';\n\n  &:hover {\n    color: #D2DBF9;\n    transition: color 500ms ease;\n  }\n\n  &::after {\n    content: url(', ');\n    display: inline-block;\n    margin-left: ', ';\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  margin-right: ', ';\n'], ['\n  margin-right: ', ';\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(38);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(21);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactHelmet = __webpack_require__(43);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _get = __webpack_require__(19);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _favicon16x = __webpack_require__(665);
	
	var _favicon16x2 = _interopRequireDefault(_favicon16x);
	
	var _favicon32x = __webpack_require__(666);
	
	var _favicon32x2 = _interopRequireDefault(_favicon32x);
	
	var _SiteHeader = __webpack_require__(351);
	
	var _SiteHeader2 = _interopRequireDefault(_SiteHeader);
	
	var _instagramLogo = __webpack_require__(668);
	
	var _instagramLogo2 = _interopRequireDefault(_instagramLogo);
	
	var _linkArrow = __webpack_require__(669);
	
	var _linkArrow2 = _interopRequireDefault(_linkArrow);
	
	var _pistachioCombined = __webpack_require__(671);
	
	var _pistachioCombined2 = _interopRequireDefault(_pistachioCombined);
	
	var _variables = __webpack_require__(16);
	
	var _globalStyles = __webpack_require__(361);
	
	var _globalStyles2 = _interopRequireDefault(_globalStyles);
	
	var _typography = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SiteTitle = _styledComponents2.default.h1(_templateObject, _variables.Colors.pageBackground);
	
	var FooterWrapper = _styledComponents2.default.footer(_templateObject2, _variables.Spacing.spacingXLarge);
	
	var FooterCTAText = _styledComponents2.default.a(_templateObject3);
	
	var InstagramIcon = _styledComponents2.default.img(_templateObject4, _variables.Spacing.spacingSmall);
	
	var FooterLinks = _styledComponents2.default.div(_templateObject5, _variables.Sizes.breakpointSmall);
	
	var GitHubLink = _styledComponents2.default.a(_templateObject6, _variables.Colors.linkColor, _linkArrow2.default, _variables.Spacing.spacingSmall);
	
	var FooterCopyright = _styledComponents2.default.small(_templateObject7, _variables.Spacing.spacingBase);
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	    var header = void 0;
	
	    var rootPath = '/';
	    if (false) {
	      rootPath = __PATH_PREFIX__ + '/';
	    }
	
	    if (location.pathname === rootPath) {
	      header = _react2.default.createElement(_SiteHeader2.default, null);
	    } else {
	      header = _react2.default.createElement(_SiteHeader2.default, null);
	    }
	
	    var siteTitle = (0, _get2.default)(this, 'props.data.site.siteMetadata.title');
	
	    var helmet = _react2.default.createElement(_reactHelmet2.default, {
	      title: siteTitle,
	      meta: [{
	        name: "description",
	        content: "Ice Cream on a Sunday - A blog about ice cream"
	      }, {
	        name: "keywords",
	        content: "ice cream, blog, sundae, sunday"
	      }, {
	        name: "og:image",
	        content: { metaImage: _pistachioCombined2.default }
	      }, {
	        name: "og:type",
	        content: "blog"
	      }],
	      link: [{ rel: "icon", type: "image/png", sizes: "16x16", href: '' + _favicon16x2.default }, { rel: "icon", type: "image/png", sizes: "32x32", href: '' + _favicon32x2.default }]
	    });
	
	    var footer = _react2.default.createElement(
	      FooterWrapper,
	      null,
	      _react2.default.createElement(
	        FooterCTAText,
	        {
	          href: 'https://www.instagram.com/icecreamonasunday' },
	        'Follow on Instagram'
	      ),
	      _react2.default.createElement(InstagramIcon, {
	        src: _instagramLogo2.default
	      }),
	      _react2.default.createElement(
	        FooterLinks,
	        null,
	        _react2.default.createElement(
	          FooterCopyright,
	          null,
	          '\xA9 Vendela Larsson ',
	          new Date().getFullYear()
	        ),
	        _react2.default.createElement(
	          GitHubLink,
	          {
	            href: 'https://github.com/vendelal/ice-cream-on-a-sunday' },
	          'Check out this project on GitHub'
	        )
	      )
	    );
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      helmet,
	      header,
	      children(),
	      footer
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n\n  // FONTS\n\n  @font-face {\n    font-family: \"Circular-Regular\";\n    font-style: normal;\n    font-weight: normal;\n    src: local(\"CircularStd-Book\"), url(", ") format(\"woff\");\n  }\n\n  @font-face {\n    font-family: \"Circular-Bold\";\n    font-style: normal;\n    font-weight: normal;\n    src: local(\"CircularStd-Bold\"), url(", ") format(\"woff\");\n  }\n\n  @font-face {\n    font-family: \"Ahkio-Regular\";\n    font-style: normal;\n    font-weight: normal;\n    src: local(\"Ahkio-Regular\"), url(", ") format(\"woff\");\n  }\n\n  @font-face {\n    font-family: \"Ahkio-Bold\";\n    font-style: normal;\n    font-weight: normal;\n    src: local(\"Ahkio-Bold\"), url(", ") format(\"woff\");\n  }\n\n\n  // ANIMATIONS\n\n  @keyframes fade-in {\n    0% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fade-in-down {\n    0% {\n      opacity: 0;\n      transform: translateY(-15px);\n    }\n\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes fade-in-right {\n    0% {\n      opacity: 0;\n      transform: translateX(-15px);\n    }\n\n    100% {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n"], ["\n\n  // FONTS\n\n  @font-face {\n    font-family: \"Circular-Regular\";\n    font-style: normal;\n    font-weight: normal;\n    src: local(\"CircularStd-Book\"), url(", ") format(\"woff\");\n  }\n\n  @font-face {\n    font-family: \"Circular-Bold\";\n    font-style: normal;\n    font-weight: normal;\n    src: local(\"CircularStd-Bold\"), url(", ") format(\"woff\");\n  }\n\n  @font-face {\n    font-family: \"Ahkio-Regular\";\n    font-style: normal;\n    font-weight: normal;\n    src: local(\"Ahkio-Regular\"), url(", ") format(\"woff\");\n  }\n\n  @font-face {\n    font-family: \"Ahkio-Bold\";\n    font-style: normal;\n    font-weight: normal;\n    src: local(\"Ahkio-Bold\"), url(", ") format(\"woff\");\n  }\n\n\n  // ANIMATIONS\n\n  @keyframes fade-in {\n    0% {\n      opacity: 0;\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fade-in-down {\n    0% {\n      opacity: 0;\n      transform: translateY(-15px);\n    }\n\n    100% {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes fade-in-right {\n    0% {\n      opacity: 0;\n      transform: translateX(-15px);\n    }\n\n    100% {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n"]);
	
	var _styledComponents = __webpack_require__(21);
	
	var _fontFiles = __webpack_require__(362);
	
	var fontFiles = _interopRequireWildcard(_fontFiles);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	exports.default = (0, _styledComponents.injectGlobal)(_templateObject, fontFiles.bodyFont, fontFiles.bodyFontBold, fontFiles.headerFontRegular, fontFiles.headerFontBold);
	module.exports = exports["default"];

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.headerFontBlack = exports.headerFontBold = exports.headerFontRegular = exports.bodyFontBold = exports.bodyFont = undefined;
	
	var _CircularStdBook = __webpack_require__(467);
	
	var _CircularStdBook2 = _interopRequireDefault(_CircularStdBook);
	
	var _CircularStdBold = __webpack_require__(466);
	
	var _CircularStdBold2 = _interopRequireDefault(_CircularStdBold);
	
	var _AhkioRegular = __webpack_require__(465);
	
	var _AhkioRegular2 = _interopRequireDefault(_AhkioRegular);
	
	var _AhkioBold = __webpack_require__(464);
	
	var _AhkioBold2 = _interopRequireDefault(_AhkioBold);
	
	var _AhkioBlack = __webpack_require__(463);
	
	var _AhkioBlack2 = _interopRequireDefault(_AhkioBlack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bodyFont = exports.bodyFont = _CircularStdBook2.default;
	var bodyFontBold = exports.bodyFontBold = _CircularStdBold2.default;
	var headerFontRegular = exports.headerFontRegular = _AhkioRegular2.default;
	var headerFontBold = exports.headerFontBold = _AhkioBold2.default;
	var headerFontBlack = exports.headerFontBlack = _AhkioBlack2.default;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-018119e8a2fa551fa5ef.js